export const paths = {
  home: '/',
  app: {
    home: '/app',
    auth: { signIn: '/app/auth/sign-in', signUp: '/app/auth/sign-up', resetPassword: '/app/auth/reset-password' },
    client: {
      home: '/app/client',
      projects: {
        home: '/app/client/projects',
        details: '/app/client/projects/:projectId',
        getDetailsUrl: (projectId: string): string => `/app/client/projects/${projectId}`,
        add: '/app/client/projects/add',
      },
      plants: {
        home: '/app/client/plants',
        details: '/app/client/plants/:plantId',
        getDetailsUrl: (plantId: string): string => `/app/client/plants/${plantId}`,
      },
      users: {
        details: '/app/client/users/:userId',
        getDetailsUrl: (userId: string): string => `/app/client/users/${userId}`,
      },
    },
    admin: {
      home: '/app/admin',
      organisations: {
        home: '/app/admin/organisations',
        details: '/app/admin/organisations/:organisationId',
        getDetailsUrl: (organisationId: string): string => `/app/admin/organisations/${organisationId}`,
        add: '/app/admin/organisations/add',
      },
      users: {
        home: '/app/admin/users',
        details: '/app/admin/users/:userId',
        add: '/app/admin/users/add',
        getDetailsUrl: (userId: string): string => `/app/admin/users/${userId}`,
      },
      frameworks: {
        home: '/app/admin/frameworks',
        details: '/app/admin/frameworks/:frameworkId',
        getDetailsUrl: (frameworkId: string): string => `/app/admin/frameworks/${frameworkId}`,
        add: '/app/admin/frameworks/add',
      },
    },
  },
  errors: {
    notFound: '/errors/not-found',
    notNotAuthorized: '/errors/not-authorized',
  },
} as const;
